import { faBullhorn } from '@fortawesome/pro-regular-svg-icons';
import { SearchHit } from 'api/search';
import { SearchHitHighlightOrDocumentValue } from 'components/search/SearchHitHighlightOrDocumentValue';
import * as SearchResults from 'components/search/SearchResults';
import { useSearchResultsProps } from 'components/tasks/utils/useLinkSearchResults';
import { Campaign } from 'types/domain';

interface CampaignResultsProps {
    onSelect: (hit: SearchHit<Campaign>) => void;
}
const CampaignResults = ({ onSelect }: CampaignResultsProps) => {
    const { isEmpty, getKey, data } = useSearchResultsProps('campaigns');

    if (isEmpty) {
        return null;
    }

    return (
        <SearchResults.Root>
            <SearchResults.Title>Campaigns</SearchResults.Title>
            {data.hits.map(hit => {
                return (
                    <SearchResults.ListItem
                        key={getKey(hit.document.id)}
                        onClick={() => onSelect(hit)}
                    >
                        <SearchResults.Icon icon={faBullhorn} />
                        <SearchHitHighlightOrDocumentValue
                            hit={hit}
                            documentKey="title"
                            className="font-medium"
                        />
                    </SearchResults.ListItem>
                );
            })}
        </SearchResults.Root>
    );
};

export { CampaignResults };
